<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>
      {{pageTitle}}
    </h4>
  </div>

  <div class="modal-body">
    <form [formGroup]="formQualification" *ngIf="formQualification" #form="ngForm" (submit)="onSubmit()">
      <div class="mb-3">
        <label for="cdcs" class="col-form-label" translate>page.admin.jure.qualifications.cdc</label>
          <app-multiselect id="cdcs" class="col-md-6"
                           controlName="cdcs"
                           [items]="cdcs"
                           bindLabel="libelle"
                           maxWidth="initial"
                           [ngClass]="{ 'is-invalid': form.submitted && cdcs.invalid }">
          </app-multiselect>
      </div>
      <div class="mb-2" *ngIf="!idQualif">
        <button type="button" class="btn btn-sm btn-outline-secondary mr-2"
                (click)="cdcsCtrl.setValue(cdcs)">
          Tout sélectionner
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="cdcsCtrl.setValue([])">
          Tout désélectionner
        </button>
      </div>
      <div class="mb-3">
        <label class="form-label" for="dateFormationIni" translate>page.admin.jure.qualifications.dateFormationInitiale</label>
        <div class="input-group">
          <input id="dateFormationIni" ngbDatepicker #dateFormationInit="ngbDatepicker" formControlName="dateFormationIni" class="form-control"/>
          <div class="input-group-append">
            <button type="button" (click)="dateFormationInit.toggle()" class="btn btn-secondary">
              <fa-icon icon="calendar-alt"></fa-icon>
            </button>
          </div>
          <div class="text-danger"
              *ngIf="formQualification.get('dateFormationIni')?.touched &&
                      formQualification.get('dateFormationIni')?.errors?.required">
            La date de formation initiale est obligatoire
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label" for="dateFormationDer" translate>page.admin.jure.qualifications.dateDerniereFormation</label>
        <div class="input-group">
          <input id="dateFormationDer" ngbDatepicker #dateFormationDer="ngbDatepicker" formControlName="dateFormationDer" class="form-control"/>
          <div class="input-group-append">
            <button type="button" (click)="dateFormationDer.toggle()" class="btn btn-secondary">
              <fa-icon icon="calendar-alt"></fa-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3" [ngClass]="{ 'is-invalid': form.submitted && college.invalid }">
        <label for="college" class="col-form-label" translate>page.admin.jure.qualifications.college</label>
          <select id="college" formControlName="college" class="form-control">
            <option [value]="null" hidden></option>
            <option *ngFor="let college of refColleges" [ngValue]="college">{{college.libelle}}</option>
          </select>

      </div>

      <div class="mb-3">
        <label class="form-label" for="operateur" translate>page.admin.jure.qualifications.operateur</label>
        <app-search-intervenant-organisme-bar id="operateur" [operateur]="this.operateurSearch" (newItemEvent)="selectOperateur($event)" ></app-search-intervenant-organisme-bar>
      </div>

      <div class="actions-bar">
        <button type="button" (click)="onClose()" class="btn btn-light" translate>label.annuler</button>
        <button type="submit" class="btn btn-primary" translate>label.valider</button>
      </div>
    </form>
  </div>
</div>

